import { Link } from 'react-router-dom';
import { PageContainer } from '@/shared/components/layout';
import { buttonVariants, EmptyState } from '@/shared/components/ui';
import { useT } from '@/shared/i18n/useT';

export function NotFound() {
  const { t } = useT();
  return (
    <PageContainer width="narrow">
      <EmptyState
        icon="mercado"
        title={t('states.notFoundTitle')}
        description={t('states.notFoundText')}
        action={
          <Link to="/" className={buttonVariants({ variant: 'primary' })}>
            {t('actions.goHome')}
          </Link>
        }
      />
    </PageContainer>
  );
}
